const styles = (theme) => ({
  address: {
    ...theme.typography.bod1,
    color: theme.palette.text.primary,
  },
});

export default styles;
